import React from 'react'
import { createRoot } from 'react-dom/client'
import ProductTile from "./ProductTile.jsx"

const appAttribute = 'product-tile'

document.addEventListener('DOMContentLoaded', () => {
  // const observeRoot = document.querySelector('#MainContent')
  // const config = { childList: true, subtree: true }
  // const observer = new MutationObserver(observerCallback)
  // observer.observe(observeRoot, config)

  if(document.body.classList.contains('template-collection') && location.search == '' && (typeof window.collectionData != 'undefined' && window.collectionData.sort_order != 'manual')) {
    
  } else {
    const productTiles = document.querySelectorAll(`[${appAttribute}]`)
    productTiles.forEach((tile) => setupProductTile(tile))
  }
})

const observerCallback = (mutationList, observer) => {
  mutationList.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof HTMLElement)) return
      if (node.hasAttribute(appAttribute)) setupProductTile(node)
    })
  })
}


const setupProductTile = (productTileEl) => {
  if(typeof productTileEl != 'undefined') {
    const propsRaw = productTileEl.getAttribute('props')
    const props = JSON.parse(propsRaw)

    const root = createRoot(productTileEl)
    root.render(<ProductTile props={props} />)
  }
}

window.setupATile = setupProductTile

window.setupProductTiles = (tiles) => {
  tiles.forEach((tile) => setupProductTile(tile))
}